'use memo';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { AlertCard } from '@/components/AlertCard';
import { VStack } from '@/components/Layout';
import { ViewportLoader } from '@/components/Loading';
import { toast } from '@/components/ui/use-toast';
import { PolicyForm, authPoliciesKeyPrefix, toPolicyFormValue, useAuthenticationPolicy, useUpdateAuthenticationPolicy } from '@/features/authentication-policy';
import { PolicySectionHeader } from '@/features/identity-policy';
import { handleApiError } from '@/lib/api/error';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/policies/$id/')({
  component: EditAuthPolicyPage
});
function EditAuthPolicyPage() {
  const {
    id
  } = Route.useParams();
  const {
    i18n,
    t
  } = useTranslation(defaultNS, {
    keyPrefix: authPoliciesKeyPrefix
  });
  const navigate = useNavigate();
  const {
    data,
    isPending,
    isError
  } = useAuthenticationPolicy(id);
  const updateMutation = useUpdateAuthenticationPolicy();
  const [errorMessage, setErrorMessage] = useState('');
  const backToList = () => navigate({
    to: '/settings/authentication/policies'
  });
  if (isPending) return <ViewportLoader />;
  if (isError || data == null) {
    return <VStack className="w-full gap-4 px-12 py-6">
        <PolicySectionHeader iconName="ShieldCheckIcon" title={t($ => $.form.editTitle)} description={t($ => $.description)} />
        <AlertCard variant="mutedError" description={t($ => $.list.loadError)} />
      </VStack>;
  }
  return <VStack className="w-full gap-4 px-12 py-6">
      <PolicySectionHeader iconName="ShieldCheckIcon" title={t($ => $.form.editTitle)} description={data.name} />
      <PolicyForm
    // 取得後に一度だけフォームを初期化する（再取得で編集内容を巻き戻さない）。
    // `toPolicyFormValue` は crypto.randomUUID を使うため render 内では呼べない。
    key={data.id} initialValue={() => toPolicyFormValue(data)} isDefault={data.isDefault} isSubmitting={updateMutation.isPending} errorMessage={errorMessage} onCancel={() => void backToList()} onSubmit={draft => {
      setErrorMessage('');
      updateMutation.mutate({
        ...draft,
        id
      }, {
        onSuccess: () => {
          toast({
            description: t($ => $.toast.updated)
          });
          void backToList();
        },
        onError: error => {
          setErrorMessage(handleApiError(error, {
            language: i18n.language
          }).message);
        }
      });
    }} />
    </VStack>;
}